import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pagination',
  imports: [NgbPagination, FormsModule],
  templateUrl: './pagination.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
  @Input() page: number = 1;
  @Input() limit: number = 10;
  @Input() collectionSize: number = 0;

  @Output() changePageEvent = new EventEmitter<number>();
  @Output() changeLimitEvent = new EventEmitter<number>();

  changePage(): void {
    this.changePageEvent.emit(this.page);
  }

  changeLimit(limit: string): void {
    this.limit = Number(limit);
    this.changeLimitEvent.emit(this.limit);
  }
}
